import axios from "axios";

import { logoutStartAction, logoutSuccessAction, logoutFailAction } from "../actions";
import { emptyCampaigns } from "../../campaigns/actions";
import { emptyContactsList } from "../../contacts/actions";
import { emptyGroups } from "../../groups/actions";

const logout = (token) => async (dispatch) => {
  try {
    dispatch(logoutStartAction());
    const { status } = await axios.get("/api/v1/logout", {
      headers: {
        Authorization: token,
      },
    });
    if (status === 200) {
      dispatch(logoutSuccessAction());
      dispatch(emptyCampaigns());
      dispatch(emptyContactsList());
      dispatch(emptyGroups());
    }
  } catch (error) {
    const errorMsg =
      error &&
      error.response &&
      error.response.data &&
      error.response.data.error &&
      error.response.data.error.msg;
    dispatch(logoutFailAction(errorMsg || "Something went wrong, please try again!"));
  }
};

export default logout;
